export const getRandomInt = (max: number) => Math.floor(Math.random() * (max + 1));

